import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private localStorageKey = 'navigation';
  public navigationItems: NavigationItem[] = [];

  constructor() {
    // Check local storage for navigation items
    let items = sessionStorage.getItem(this.localStorageKey);
    if (items) {
      this.navigationItems = JSON.parse(items);
    }
  }

  public track(data: NavigationItem) {
    let item = this.navigationItems.find(x => x.route === data.route);

    if (item) {
      this.update(data);
    } else {
      this.add(data);
    }

    this.save();
  }

  public get(route: NavRoute) {
    return this.navigationItems.find(x => x.route === route);
  }

  private update(data: NavigationItem) {
    let index = this.navigationItems.findIndex(x => x.route === data.route);
    this.navigationItems[index] = data;
  }

  private add(data: NavigationItem) {
    this.navigationItems.push(data);
  }

  private save() {
    sessionStorage.setItem(this.localStorageKey, JSON.stringify(this.navigationItems));
  }
}

export interface NavigationItem {
  route: NavRoute;
  fragment?: string;
  lastId?: string;
}

export enum NavRoute {
  Trial,
  Patient
}
